import type { Theme } from '@mui/material/styles';

import Button from './Button';
import Chip from './Chip';

export default function ComponentsOverrides(theme: Theme) {
  return Object.assign(Chip(theme), Button(theme));
}
